import { Email } from '../types/email';

export const sampleEmails: Email[] = [
  {
    id: '1',
    from: 'john.smith@acme.com',
    to: ['user@company.com'],
    subject: 'Due Diligence Report - Q1 2024',
    content: `Hi Team,

I've completed the initial due diligence report for the Tech Corp acquisition. Key findings:

1. Financial Health
   - Strong revenue growth (25% YoY)
   - Healthy margins (28% EBITDA)
   - Clean audit history

2. Market Position
   - #2 in market share
   - Growing customer base
   - Strong brand recognition

3. Technology Stack
   - Modern architecture
   - High scalability
   - Good security practices

Please review and let me know your thoughts.

Best regards,
John`,
    timestamp: new Date().toISOString(),
    isRead: false,
    isStarred: true,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-1',
    labels: ['due-diligence', 'high-priority'],
    attachments: [
      { id: 'a1', name: 'Due_Diligence_Report_Q1.pdf', size: 2500000, type: 'application/pdf' },
      { id: 'a2', name: 'Financial_Analysis.xlsx', size: 1800000, type: 'application/xlsx' }
    ]
  },
  {
    id: '2',
    from: 'sarah.johnson@legal.com',
    to: ['user@company.com'],
    subject: 'Urgent: Merger Agreement Review Required',
    content: `Dear Team,

The updated merger agreement requires immediate attention. Key changes include:

1. Purchase Price Adjustments
   - Working capital threshold modified
   - Earnout structure revised
   - New escrow provisions

2. Representations & Warranties
   - Extended survival period
   - Modified materiality scrape
   - Additional tech-specific reps

Please review by EOD. We need to respond to the counterparty tomorrow.

Best regards,
Sarah`,
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    isRead: false,
    isStarred: true,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-2',
    labels: ['legal', 'urgent'],
    attachments: [
      { id: 'a3', name: 'Merger_Agreement_v3.docx', size: 1500000, type: 'application/docx' }
    ]
  },
  {
    id: '3',
    from: 'michael.chen@finance.com',
    to: ['user@company.com'],
    subject: 'Updated Valuation Models - Manufacturing Deal',
    content: `Hi team,

I've updated the valuation models with the latest projections:

1. DCF Analysis
   - Updated growth rates
   - Revised WACC calculation
   - New terminal value assumptions

2. Trading Comps
   - Added new peer companies
   - Updated multiples
   - Refreshed operating metrics

3. Transaction Comps
   - Added recent deals
   - Adjusted for market conditions
   - Updated synergy estimates

The new valuation range is $120M-$150M.

Best,
Michael`,
    timestamp: new Date(Date.now() - 7200000).toISOString(),
    isRead: true,
    isStarred: false,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-2',
    labels: ['financial', 'valuation'],
    attachments: [
      { id: 'a4', name: 'Valuation_Models_v2.xlsx', size: 3200000, type: 'application/xlsx' }
    ]
  },
  {
    id: '4',
    from: 'david.wilson@operations.com',
    to: ['user@company.com'],
    subject: 'Integration Planning Update',
    content: `Team,

Here's the latest on integration planning:

1. IT Systems
   - System mapping completed
   - Migration timeline drafted
   - Key risks identified

2. Personnel
   - Org structure proposed
   - Key positions identified
   - Retention plans drafted

3. Operations
   - Facility consolidation plan
   - Supply chain integration
   - Customer transition strategy

Let's discuss in tomorrow's meeting.

Regards,
David`,
    timestamp: new Date(Date.now() - 14400000).toISOString(),
    isRead: true,
    isStarred: false,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-1',
    labels: ['integration', 'operations'],
    attachments: [
      { id: 'a5', name: 'Integration_Plan.pptx', size: 4500000, type: 'application/pptx' }
    ]
  },
  {
    id: '5',
    from: 'emma.brown@advisory.com',
    to: ['user@company.com'],
    subject: 'Synergy Analysis Complete',
    content: `Hi,

The synergy analysis is complete. Key findings:

1. Cost Synergies
   - Operational efficiencies: $5M
   - Headcount optimization: $3M
   - IT consolidation: $2M

2. Revenue Synergies
   - Cross-selling: $8M
   - Market expansion: $4M
   - Product integration: $3M

Total value creation potential: $25M

Best regards,
Emma`,
    timestamp: new Date(Date.now() - 28800000).toISOString(),
    isRead: true,
    isStarred: true,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-2',
    labels: ['financial', 'synergies'],
    attachments: [
      { id: 'a6', name: 'Synergy_Analysis.pdf', size: 2800000, type: 'application/pdf' }
    ]
  },
  {
    id: '6',
    from: 'robert.taylor@target.com',
    to: ['user@company.com'],
    subject: 'Data Room Access Request',
    content: `Hello,

Our team needs access to the following data room sections:

1. Financial Information
2. HR Documents
3. IT Systems Documentation
4. Customer Contracts

Please grant access to:
- jane.doe@target.com
- mark.smith@target.com
- lisa.wong@target.com

Thank you,
Robert`,
    timestamp: new Date(Date.now() - 86400000).toISOString(),
    isRead: true,
    isStarred: false,
    hasAttachments: false,
    folder: 'inbox',
    dealId: 'deal-1',
    labels: ['data-room', 'access']
  },
  {
    id: '7',
    from: 'alice.garcia@compliance.com',
    to: ['user@company.com'],
    subject: 'Regulatory Filing Update',
    content: `Team,

Update on regulatory filings:

1. Antitrust
   - HSR filing prepared
   - Second request risk assessment
   - Timeline implications

2. Industry-Specific
   - FCC approval process
   - State-level requirements
   - International considerations

Next steps outlined in the attached memo.

Regards,
Alice`,
    timestamp: new Date(Date.now() - 172800000).toISOString(),
    isRead: true,
    isStarred: false,
    hasAttachments: true,
    folder: 'inbox',
    dealId: 'deal-2',
    labels: ['legal', 'regulatory'],
    attachments: [
      { id: 'a7', name: 'Regulatory_Memo.pdf', size: 1200000, type: 'application/pdf' }
    ]
  }
];